//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Toggle from '~/components/Toggle/Toggle.vue';
import bottomHero from '~/components/HomePage/elements/BottomHero';
import intercomBubble from '~/components/IntercomBubble/IntercomBubble';

export default {
  components: {
    // 'an-toggle': Toggle,
    bottomHero,
    intercomBubble,
  },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      personalizationData: {},
      timeInPage: 1,
      intercomBubbleId: null,
      showIntercomBubble: false,
      intercomBubbleContact: 'anima',
      intercomBubbleMessage:
        'Hi 👋<br />We have a special offer for September only!<br /><b>50% off the first 3 months</b>, click here to redeem',
      timeoutIds: [],
      isAnnual: true,
      isMobile: false,
      isPricingScreenFlowActive: false,
      stigg: null,
      countryCode: 'US',
    };
  },
  computed: {
    contactUsUrl() {
      const resultUrl = new URL('https://anima-storybook.typeform.com/to/Vkt8zmCd');
      if (process.client) {
        const currentSearchParams = new URLSearchParams(window?.location.search);
        for (const [key, value] of currentSearchParams.entries()) {
          resultUrl.searchParams.set(key, value);
        }
      }
      return resultUrl.toString();
    },
    columns() {
      const columns = this.blok.columns;
      const freePlan = this.getPlanByName('Free');
      const proPlan = this.getPlanByName('Pro');
      const teamPlan = this.getPlanByName('Team');
      const businessPlan = this.getPlanByName('Business');

      let screenRelevantColumns = [freePlan, proPlan, teamPlan, businessPlan];

      if (process.client && window?.innerWidth < 1070) {
        screenRelevantColumns = [businessPlan, proPlan, teamPlan, freePlan];
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.isMobile = true;
      }
      if (screenRelevantColumns.some((item) => !item)) return columns;

      return screenRelevantColumns;
    },
    activeExperimentName() {
      if (this.isPricingScreenFlowActive) {
        return 'pricing_screen_flow';
      }
      return null;
    },
  },
  mounted() {
    if (!this.stigg) {
      this.stigg = Stigg({ apiKey: process.env.stiggToken });
    }
    this.getUserCountryCode().then((localizationData) => {
      this.countryCode = localizationData?.country_code;

      const paywall = this.stigg.Paywall({
        highlightedPlanId: 'plan-anima-pro',
        billingCountryCode: this.countryCode || 'US',
        textOverrides: {
          highlightChip: 'Popular',
          planCTAButton: {
            startNew: 'Get plan',
            upgrade: 'Get plan',
            custom: 'Contact us'
          },
          price: {
            custom: 'Custom',
            priceNotSet: 'Price not set'
          }
        },
        preferredBillingPeriod: 'yearly',
        onPlanSelected: (args) => {
          const { intentionType, selectedBillingPeriod, plan } = args;
          if (intentionType === "REQUEST_CUSTOM_PLAN_ACCESS") {
            window.location.href = this.contactUsUrl;
          } else {
            window.location.href = `https://projects.animaapp.com/payment-confirmation?intentionType=${intentionType}&interval=${selectedBillingPeriod}&plan=${plan.id}`;
          }
        },
        shouldHidePlan: (plan) => {
          return plan.id === 'plan-anima-pro-promotion';
        },
      });
      paywall.mount('#paywall');
    });

    this.$intercom('boot');
    this.checkTimeZoneFeatures();
    this.timeoutIds.push(
      setTimeout(this.promptIntercomBubble, this.timeInPage * 1000)
    );
    const personalizationData = fetch('https://api.animaapp.com/rpc/get_personalization_data', {
      method: 'GET'
    }
    ).then((response) => response.json());
    this.personalizationData = personalizationData;
  },

  beforeDestroy() {
    this.clearTimeouts();
    this.$intercom('shutdown');
    this.hideIntercomBubble();
  },
  methods: {
    async getUserCountryCode() {
      try {
        const response = await fetch('https://ipapi.co/json/');
        const payload = await response.json();
        return payload;
      } catch (error) {
        errorHandler.captureException("Couldn't get user localization data from ipapi.co");
      }
    },
    getPlanByName(name) {
      return this.blok.columns.find(({ planName }) => planName === name);
    },
    async checkTimeZoneFeatures() {
      const featureName = 'tz.show.pricing-screen-based-flow';
      const date = new Date();
      const offset = date.getTimezoneOffset();
      const hour = (-1 * offset) / 60;
      const params = {
        hour,
        feature: featureName,
      };
      const resp = await this.$animaapi.get('/get_time_zone_feature_flags', {
        params,
      });
      const experiments = {};
      Object.entries(resp.data || {}).map(
        ([feature, enabled]) => (experiments[feature] = enabled === 'TRUE')
      );
      if (experiments[featureName]) {
        localStorage.setItem('pricingScreenFlowActive', true);
      }
      const pricingScreenFlowActive = localStorage.getItem(
        'pricingScreenFlowActive'
      );
      this.isPricingScreenFlowActive = !!(
        pricingScreenFlowActive || experiments[featureName]
      );
    },
    trackIdleTime({ timeInPage }) {
      this.$tracking.trackEvent('website.page.idle', {
        timeInPage,
        screenWidth: window?.innerWidth,
        page: 'pricing',
      });
    },
    promptIntercomBubble() {
      if (new Date() < new Date('2021-10-01')) {
        const { timeInPage } = this;
        this.showIntercomBubble = true;
        this.trackIdleTime({ timeInPage });
      }
    },
    hideIntercomBubble() {
      this.showIntercomBubble = false;
    },
    clearTimeouts() {
      for (const id of this.timeoutIds) {
        clearTimeout(id);
      }
    },
    goToWebappPayment() {
      window.location.href =
        'https://projects.animaapp.com/payment?plan=pro&interval=monthly&promo_code=sep-2021-offer';
    },
    trackContactUs() {
      this.$tracking.trackEvent('pricing.contact-us.click');
    },
  },
};
